import { DashboardService, DashboardStats, StatusStats } from './../../../services/dashboard.service';
import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { MaterialModule } from '../../../material.module';
import { InquiryStatus, InquiryStatusMap } from '../../../models/inquiry.model';
import { formatAmount } from '../../../misc/functions';

@Component({
  selector: 'app-admin-dashboard',
  standalone: true,
  imports: [CommonModule, RouterModule, MaterialModule],
  templateUrl: './admin-dashboard.component.html',
  styleUrls: ['./admin-dashboard.component.scss']
})
export class AdminDashboardComponent implements OnInit {
  stats: DashboardStats|null = null;
  isLoaded = false;
  InquiryStatusMap = InquiryStatusMap;
  formatAmount = formatAmount;

  categories = [
    {key: 'inquiries', label: 'お問い合わせ'},
    {key: 'withdrawals', label: '出金依頼' },
    {key: 'transfers', label: '振替依頼' },
    {key: 'invest', label: '新規出資依頼' },
  ];

  constructor(
    private dashboardService: DashboardService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.dashboardService.getStats().subscribe(stats => {
      this.stats = stats
      this.isLoaded = true;
    });
  }

  getStatusMap(cat: string) {
    const tmp = cat as 'お問い合わせ' | '出金依頼' | '振替依頼';
    return this.InquiryStatusMap[tmp];
  }

  getStatusList(stats: any, category: string, desiredOrder: readonly string[]): { label: string; total: number; priorities: { [priority: string]: number } }[] {
    const result: { label: string; total: number; priorities: { [priority: string]: number } }[] = [];

    for (const status of desiredOrder) {
      const breakdown = stats[category][status];
      if (!breakdown) continue;

      const { total, ...priorities } = breakdown;
      result.push({
        label: status,
        total,
        priorities
      });
    }

    return result;
  }

  getPriorityBreakdownText(status: { priorities: { [priority: string]: number } }): string {
    return Object.entries(status.priorities)
      .map(([priority, count]) => `${priority} : ${count} `)
      .join(',　');

  }

  link(uri: string, category: string|undefined) {
    if (category) {
      this.router.navigate([uri], {queryParams: {category: category}});
    }
    else {
      this.router.navigate([uri]);
    }
  }

}
